import Box from "@mui/material/Box";
import { useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import Alert from "@mui/material/Alert";
import { emailRegex } from "../../utils/regex";

export default function AddUserModal({
  accessLevels,
  setOpenAddUser,
  refreshUsers,
}) {
  const url = process.env.REACT_APP_URL;

  //Add User State
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [userLevel, setUserLevel] = useState(0);
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        setOpenAddUser(false);
        refreshUsers();
      }
    }, duration);
  };

  const handleValidation = () => {
    setDisable(true);
    if (username === "") {
      handleAlert("Please enter a username", "warning");
    } else if (email === "" || !email.match(emailRegex)) {
      handleAlert("Please enter a valid email", "warning");
    } else if (userLevel === 0) {
      handleAlert("Please select a user level", "warning");
    } else {
      handleAddUser();
    }
  };

  const handleAddUser = async () => {
    const reqBody = {
      currentUser: localStorage.getItem("userId"),
      username: username.trim(),
      email: email,
      userLevel: userLevel,
    };
    await axios
      .post(`${url}/users/create-user`, reqBody)
      .then((res) => {
        handleAlert(`${res.data.message}`, "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        if (err.status === 409) {
          handleAlert(`${err.response.data.message}`, "error");
        } else {
          handleAlert("Something went wrong - Please try again", "error");
        }
      });
  };

  return (
    <Box className="add-user-modal">
      <section className="add-user-section">
        <h2>Add User</h2>
        <form className="add-user-form">
          <input
            value={username}
            placeholder="Enter Username"
            type="text"
            onChange={(e) => setUsername(e.target.value)}
            maxLength={20}
          />
          <input
            value={email}
            placeholder="Enter Email"
            type="text"
            onChange={(e) => setEmail(e.target.value)}
            maxLength={50}
          />
          <select
            value={userLevel}
            onChange={(e) => {
              setUserLevel(parseInt(e.target.value));
            }}
          >
            <option value={0}>Select a user level</option>
            {accessLevels && accessLevels.length > 0
              ? accessLevels.map((level, i) => {
                  return (
                    <option key={i} value={level.levelId}>
                      {level.levelType}
                    </option>
                  );
                })
              : null}
          </select>
        </form>
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            variant="contained"
            color="error"
            onClick={() => setOpenAddUser(false)}
            disabled={disable}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={handleValidation}
            disabled={disable}
          >
            Submit
          </Button>
        </section>
      </section>
    </Box>
  );
}
